interface AddressComponent {
  name: string
  shortName: string
  types: string[]
}

interface GooglePlace {
  addressComponents?: AddressComponent[]
}

interface ParsedAddress {
  streetNumber: string
  streetName: string
  city: string
  county: string
  stateShort: string
  stateLong: string
  countryShort: string
  countryLong: string
  zipCode: string
  address: string
}

export const parseGooglePlace = (place: GooglePlace): ParsedAddress => {
  const byType = (place.addressComponents || []).reduce(
    (acc: Record<string, AddressComponent>, data) => {
      data.types.forEach((type) => {
        acc[type] = data
      })
      return acc
    },
    {},
  )

  const placeGet = (key: string, short = false): string => {
    if (!(key in byType)) {
      return ''
    }
    return short ? byType[key].shortName : byType[key].name
  }

  const result = {
    streetNumber: placeGet('street_number'),
    streetName: placeGet('route'),
    city:
      placeGet('locality') ||
      placeGet('sublocality') || // cspell:disable-line
      placeGet('sublocality_level_1') || // cspell:disable-line
      placeGet('neighborhood') ||
      placeGet('administrative_area_level_3') ||
      placeGet('administrative_area_level_2'),
    county: placeGet('administrative_area_level_2'),
    stateShort: placeGet('administrative_area_level_1', true),
    stateLong: placeGet('administrative_area_level_1'),
    countryShort: placeGet('country', true),
    countryLong: placeGet('country'),
    zipCode: placeGet('postal_code'),
  }

  const address = [result.streetNumber, result.streetName].filter(Boolean).join(' ')

  return {
    ...result,
    address,
  }
}
